import React, { useState, useEffect, useRef } from "react";
import gsap from "gsap";
import { Link } from "react-router-dom";
import { useGSAP } from "@gsap/react";
import './PortfolioHero.css'
import Header from "../../../Components/Header/Header";
import EyeAnimation from "../../../Components/EyeAnimation/EyeAnimation";
import SeoHelmet from "../../../Components/SeoHelmet";
import { useTranslation } from "react-i18next";

const PortfolioHero = () => {
  const {t , i18n} = useTranslation();
  const [coords2, setCoords2] = useState({ x: 10, y: 0 });

  const titleRef = useRef(null);
  const paragraphRef = useRef(null);
  const link1Ref = useRef(null);
  const link2Ref = useRef(null);
  const eyeRef = useRef(null);


  const handleMouseMove2 = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setCoords2({ x, y });
  };

  useGSAP(() => {
    gsap.from(titleRef.current, {
      opacity: 0,

      y: 50,
      delay: 1,
      duration: 1.5,
      ease: "power3.out",
    });

    gsap.from(paragraphRef.current, {
      opacity: 0,
      x: 100,
      duration: 1.5,
      delay: 0.5,
      ease: "power3.out",
    });

    gsap.from(link1Ref.current, {
      opacity: 0,
      y: 50,
      duration: 1.5,
      delay: 1,
      ease: "power3.out",
    });

    gsap.from(link2Ref.current, {
      opacity: 0,
      y: 50,
      duration: 1.5,
      delay: 1.2,
      ease: "power3.out",
    });
      
  gsap.from(eyeRef.current, {
    opacity: 0,
    scale:0.5,
    duration: 2,
    delay: 2, 
    ease: "power3.out",
  });
  });

  return (
    <div className="HeroSection PortfolioHero !overflow-visible relative">
        <SeoHelmet
        title="SunMed | Portfolio"
        description="SunMed: One Team with All Services under one roof — media production, social
        media, design, events, and web — all flowing from a unified creative
        vision.."
        keywords="SunMed, media production, web solutions, digital marketing, education, event management"
        url="https://sunmed.com"
        image="https://sunmed.com/images/sunmed-home-og.jpg"
      />
      <Header />
      <div className="content">
        <h1 ref={titleRef}>{t("PORTFOLIO PROJECTS")}</h1>

      
        <div className="flex justify-center items-center gap-7 flex-col md:flex-row  mt-3 md:mt-0">
          <Link
            ref={link2Ref}
            onMouseMove={handleMouseMove2}
            style={{
              backgroundImage: `radial-gradient(circle at ${coords2.x}px ${coords2.y}px, rgba(255,255,255,0.4), rgba(0,0,0,0) 40%)`,
            }}
            className="link"
          >
            {t("Start project")}
          </Link>
        </div>
      </div>
      <div   ref={eyeRef} className="eye-contaienr flex justify-center items-start absolute   ">
    <EyeAnimation />
   </div>
    
    </div>
  );
};

export default PortfolioHero;
